import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "../../../context/AuthContext";
import "./styles/MobileMenu.css";

const MobileMenu = ({ onClose }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [openSection, setOpenSection] = useState(null);

  const menuVariants = {
    hidden: { x: "100%" },
    visible: { x: 0, transition: { type: "tween", duration: 0.3 } },
    exit: { x: "100%", transition: { type: "tween", duration: 0.25 } },
  };

  const servicesItems = {
    managedServices: [
      { label: "Collaboration Solutions", href: "/services/Collaboration-Solutions" },
      { label: "Unified Communications as a service", href: "/services/Unified-Communications" },
      { label: "Contact Center as a service", href: "/services/Contact-Center" },
      { label: "Security Solutions", href: "/services/Security-Solutions" },
      { label: "Connectivity", href: "/services/Connectivity" },
      { label: "Hybrid Cloud Hosting", href: "/services/Hybrid-Cloud-Hosting" },
      { label: "Cyber Security Infrastructure", href: "/services/Cyber-Security-Infrastructure" },
    ],
    infrastructureServices: [
      { label: "Cloud Infrastructure", href: "/services/Cloud-Infrastructure" },
      { label: "Data Center Services", href: "/services/Data-Center-Services" },
      { label: "Network Infrastructure", href: "/services/Network-Infrastructure" },
      { label: "Wireless Infrastructure", href: "/services/Wireless-Infrastructure" },
      { label: "Cabling Solutions", href: "/services/Cabling-Solutions" },
      { label: "Maritime Systems", href: "/services/Maritime-Systems" },
      { label: "Intelligent Smart Cities Solutions", href: "/services/Intelligent-Smart-Cities-Solutions" },
    ],
  };

  const go = (path) => {
    onClose?.();
    navigate(path);
  };

  const handleLogout = async () => {
    await logout();
    onClose?.();
    navigate("/login");
  };

  return (
    <>
      <motion.div
        className="mobile-menu__overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      />

      <motion.aside
        className="mobile-menu"
        variants={menuVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className="mobile-menu__content">
          <div className="mobile-menu__header">
            <h3>Navigation</h3>
            <button className="mobile-menu__close" onClick={onClose} aria-label="Close menu">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          <div className="mobile-menu__section">
            <button
              className="mobile-menu__section-title"
              onClick={() =>
                setOpenSection(openSection === "services" ? null : "services")
              }
            >
              Services
              <svg
                className={`mobile-menu__arrow ${openSection === "services" ? "mobile-menu__arrow--open" : ""
                  }`}
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            <AnimatePresence>
              {openSection === "services" && (
                <motion.div
                  className="mobile-menu__items"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.25 }}
                >
                  {Object.values(servicesItems).flat().map((item) => (
                    <Link
                      key={item.href}
                      to={item.href}
                      className="mobile-menu__item"
                      onClick={onClose}
                    >
                      {item.label}
                    </Link>
                  ))}

                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className="mobile-menu__section">
            <Link to="/partners" className="mobile-menu__section-title" onClick={onClose}>
              Partners
            </Link>
          </div>

          <div className="mobile-menu__section">
            <Link to="/about" className="mobile-menu__section-title" onClick={onClose}>
              About
            </Link>
          </div>

          <div className="mobile-menu__section">
            <Link to="/contact" className="mobile-menu__section-title" onClick={onClose}>
              Contact
            </Link>
          </div>

          {!user ? (
            <div className="mobile-menu__auth">
              <button className="mobile-menu__ghost-btn" onClick={() => go("/login")}>
                Login
              </button>
              <button className="mobile-menu__cta-btn" onClick={() => go("/register")}>
                Sign Up
              </button>
            </div>
          ) : (
            <div className="mobile-menu__auth">
              <button className="mobile-menu__cta-btn" onClick={() => go("/contact")}>
                Let&apos;s Meet
              </button>
              <button className="mobile-menu__ghost-btn mobile-menu__logout-btn" onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>
      </motion.aside>
    </>
  );
};

export default MobileMenu;
